/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionsskiptitle3Inputs */

const en_openquestionsskiptitle3 = /** @type {(inputs: Openquestionsskiptitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide this question. The lawyer won't see it.`)
};

const pt_openquestionsskiptitle3 = /** @type {(inputs: Openquestionsskiptitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esconder este ponto. O advogado não o verá.`)
};

/**
* | output |
* | --- |
* | "Hide this question. The lawyer won't see it." |
*
* @param {Openquestionsskiptitle3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionsskiptitle3 = /** @type {((inputs?: Openquestionsskiptitle3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionsskiptitle3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionsskiptitle3(inputs)
	return pt_openquestionsskiptitle3(inputs)
});
export { openquestionsskiptitle3 as "openQuestionsSkipTitle" }